// extracted by mini-css-extract-plugin
module.exports = {"card":"SignIn_card__2askU","description":"SignIn_description__3IRWd","fields":"SignIn_fields__flawb"};